// import { useEffect, useState } from 'react';

// const useCategoryItems = (category) => {
//   const [items, setItems] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     if (!category) return;

//     const fetchItems = async () => {
//       try {
//         const response = await fetch(`/data/${category.toLowerCase()}.json`);
//         const data = await response.json();
//         setItems(data);
//       } catch (err) {
//         console.error('Failed to load category items:', err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchItems();
//   }, [category]);

//   return { items, loading };
// };

// export default useCategoryItems;

import { useEffect, useState } from 'react';

const useCategoryItems = (category) => {
  const [items, setItems] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!category) return;

    setLoading(true);
    fetch(`/data/${category}.json`)
      .then((res) => {
        if (!res.ok) throw new Error('Failed to load data');
        return res.json();
      })
      .then((data) => {
        setItems(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, [category]);

  return { items, isLoading, error };
};

export default useCategoryItems;
